/**
 * Stable per-device UUID, persisted to localStorage.
 *
 * Sent to Monosan as the `device-token` request header (matches the existing
 * Monosan/Oxygenium contract — see `n26/monosan` `N26Headers.kt`).
 *
 * NOTE: header NAME and exact semantics for browser clients are subject to
 * confirmation with the Monosan team. The current Monosan HTTP examples show
 * `device-token` as a UUID; we generate one via `crypto.randomUUID()` and
 * persist for cross-session stability.
 */

const STORAGE_KEY = 'piranha.device-token'

export const getDeviceToken = (): string => {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing) return existing
    const fresh = crypto.randomUUID()
    localStorage.setItem(STORAGE_KEY, fresh)
    return fresh
  } catch {
    // localStorage may be unavailable (e.g. cookies blocked, private mode);
    // generate an ephemeral token for this load.
    return crypto.randomUUID()
  }
}
